import Siema from './siema';

// Used to prefetch our image and read its dimensions
const cachedImg = document.createElement("img");

export function updateZoomImg(zoomKey) {
  const src = window.rambleMaps.productZoomPhotos[zoomKey];
  cachedImg.src = src;
  const zoomImg = document.getElementById("js_product_zoom_img");
  zoomImg.style.backgroundImage = `url(${src})`;
}

// Adds a class to the zoom icon that gives it a semi-opaque background
function updateZoomIconBg(photoIdx) {
  const zoomTarget = document.getElementById("js_zoom_target");
  if (zoomTarget) {
    if (photoIdx === 2) {
      zoomTarget.classList.add("with_bg");
    } else {
      zoomTarget.classList.remove("with_bg");
    }
  }
}

function hideZoomedPhoto() {
  const zoomImg = document.getElementById("js_product_zoom_img");
  zoomImg.style.display = "none";
  const zoomTarget = document.getElementById("js_zoom_target");
  if (zoomTarget) {
    zoomTarget.style.display = "block";
  }
}

function isTouchDevice() {
 return (('ontouchstart' in window)
      || (navigator.MaxTouchPoints > 0)
      || (navigator.msMaxTouchPoints > 0));
}

function logCarouselPhotoView() {
  window.pintrk('track', 'featuredPhotoChange');
  window.fbq('trackCustom', 'featuredPhotoChange');
  window.gtag("event", "click", {
    event_category: "featuredPhotoChange",
  });
}

// The carousel onChange function needs handle multiple carousels on the same page
// so our outer function accepts the carousel index as an argument and returns
// an onChange callback for the carousel at that index
function updateFeaturedOnCarouselChange(carouselIndex) {
  return function carouselOnChange() {
    // update dot in carousel (dots used in mobile view on product page)
    const dots = document.querySelectorAll(".product_photo_dots .js_circle");
    if (dots.length) {
      dots.forEach(dot => dot.classList.remove("js_featured"));
      dots[this.currentSlide].classList.add("js_featured");
    }

    // update thumbnail selector used in larger resolution product pages and on
    // materials page at all resolutions
    const productPhotoSelector = document.querySelectorAll(".product_photo_selector")[carouselIndex];
    if (productPhotoSelector) {
      const productPhotoOptions = productPhotoSelector.querySelectorAll(".js_thumbnail");
      productPhotoOptions.forEach(img => img.classList.remove("js_featured"));
      productPhotoOptions[this.currentSlide].classList.add("js_featured");
    }

    // if we have zoom photos for our carousel (eg. product page) we'll need
    // to update them.
    if (window.rambleMaps.productZoomPhotos) {
      const zoomPhotoKey = dots[this.currentSlide].dataset.productPhotoKey;

      // Hide old zoomed photo and get the next one ready
      hideZoomedPhoto();
      updateZoomImg(zoomPhotoKey);
      updateZoomIconBg(this.currentSlide);
    }

    logCarouselPhotoView();
  }
}

function getCursorPos(container, e) {
  /* eslint-disable no-mixed-operators */
  e = e || window.event;

  /* Get the x and y positions of the image: */
  const photoRect = container.getBoundingClientRect();

  // Calculate the cursor's x and y coordinates, relative to the image:
  const pageX = e.pageX || e.touches && e.touches[0].pageX;
  const pageY = e.pageY || e.touches && e.touches[0].pageY;
  let x = pageX - photoRect.left;
  let y = pageY - photoRect.top;

  // Consider any page scrolling
  x -= window.pageXOffset;
  y -= window.pageYOffset;

  return { x, y };
}

function moveLens(container, zoomImg, containerWidth, containerHeight) {
  return function moveLensEvent(e) {
    // Prevent any other actions that may occur when moving over the image
    e.preventDefault();

    // Get the cursor's x and y positions:
    const { x, y } = getCursorPos(container, e);

    // Position background image as a % of position within container
    zoomImg.style.backgroundPosition = `${(x / containerWidth) * 100}% ${(y / containerHeight) * 100}%`;
  };
}

function showZoomProductPhoto(containerWidth, containerHeight) {
  const zoomImg = document.getElementById("js_product_zoom_img");
  const productPhotoContainer = document.getElementById("js_product_photo_container");
  return function showZoomHandler(e) {
    const { x, y } = getCursorPos(productPhotoContainer, e);
    zoomImg.style.display = "block";
    const initX = (containerWidth - cachedImg.width) * (x / containerWidth);
    const initY = (containerHeight - cachedImg.height) * (y / containerHeight);
    zoomImg.style.backgroundPosition = `${initX}px ${initY}px`;

    // Update the global storing our position so we can move incrementally
    // from it when we drag scroll (touch devices only)
    const zoomTarget = document.getElementById("js_zoom_target");
    if (zoomTarget) {
      zoomTarget.style.display = "none";
    }

    // log photo zoom
    const currentSlide = Array.from(document.querySelectorAll(".js_thumbnail"))
      .findIndex(el => el.classList.contains("js_featured"));
    window.gtag("event", "zoom", {
      event_category: "productPhotoZoom",
      event_label: `Slide ${currentSlide}`
    });
  };
}

// When the user has zoomed in on an image, we don't want their panning of that
// image to trigger a carousel image change. So while the page is zoomed, we
// turn off the carousel.
// We also remove the srcset attribute for the active image if we've zoomed so
// that our users see our highest resolution image.
function toggleCarousel(carousels, initialScale) {
  carousels.forEach(carousel => {
    const hasZoomed = window.visualViewport.scale - initialScale > 0.01;
    carousel.setDisableSiemaSwipe(hasZoomed);

    // If our carousel is on a product page, it is zoomable. When we have a
    // zoomable photo, remove the srcset attribute so we just use the src
    // image (which should be our largest size image)
    if (hasZoomed && document.querySelector(".product_body")) {
      const img = carousel.innerElements[carousel.currentSlide];
      if (img.srcset) {
        img.removeAttribute("srcset");
      }
    }
  });
}

// Zoom functionality for product photo based off of:
// https://www.w3schools.com/howto/howto_js_image_zoom.asp
export default function initCarousels() {
  const productPhotoContainer = document.getElementById("js_product_photo_container");
  const zoomImg = document.getElementById("js_product_zoom_img");

  const carousels = document.querySelectorAll(".siema");
  const carouselControllers = [];
  // Initialize each carousel
  carousels.forEach((carousel, i) => {
    // Initialize carousel, 'selector' needed for multiple instances
    const photoCarousel = new Siema({
      selector: carousel,
      onChange: updateFeaturedOnCarouselChange(i)
    });
    carouselControllers.push(photoCarousel);

    // if we have a product photo container then we are on a product page and
    // need to put the carousel on the global object so that other modules
    // can update slides
    if (productPhotoContainer) {
      window.rambleMaps.productPhotoCarousel = photoCarousel;
    }

    // Load next images in the carousel
    const carouselPhotos = carousel.querySelectorAll(".siema img");
    carouselPhotos.forEach(img => {
      if (img.dataset.src && img.dataset.src.length &&
          img.src !== img.dataset.src) {
        img.src = img.dataset.src;
      }
    });

    // handle zoom
    if (zoomImg) {
      // Init zoom image
      const titleCheckbox = document.getElementById("js_title_checkbox");
      updateZoomImg(titleCheckbox && titleCheckbox.checked ? "wall_with_title" : "wall");

      const { offsetWidth, offsetHeight } = productPhotoContainer;
      // Add handler for zooming on desktop product photo
      if (!isTouchDevice()) {
        productPhotoContainer.addEventListener("mouseenter", showZoomProductPhoto(
          offsetWidth,
          offsetHeight
        ));
        productPhotoContainer.addEventListener("mouseleave", hideZoomedPhoto);
        zoomImg.addEventListener("mousemove", moveLens(productPhotoContainer, zoomImg, offsetWidth, offsetHeight));
      }
    }

    // Add handlers for changing slides
    const goToSlideHandler = (el, i) => el.addEventListener("click", () => {
      photoCarousel.goTo(i);
    });
    const photoCarouselContainer = carousel.closest(".js_photo_carousel");
    // Add click handler for thumbnails to update carousel image
    const productPhotoOptions = photoCarouselContainer.querySelectorAll(".product_photo_selector .js_thumbnail");
    productPhotoOptions.forEach(goToSlideHandler);
    // Add click handler for carousel dots to update carousel image
    const dots = photoCarouselContainer.querySelectorAll(".product_photo_dots .js_circle");
    dots.forEach(goToSlideHandler);
  });

  // Add an event listener for pinch zoom if we have a touch device, with a
  // photo carousel on the page, and support the visualViewport object
  const pageHasCarousel = document.querySelectorAll(".siema");
  if (isTouchDevice() && pageHasCarousel && 'visualViewport' in window) {
    // remove magnifying glass icon to indicate zoom for non-touch devices
    const zoomTarget = document.getElementById("js_zoom_target");
    if (zoomTarget) {
      zoomTarget.remove();
    }

    // get the initial scale of the viewport. This value ideally reflects the
    // default browser zoom of the device but it is imperfect, eg. the user can
    // zoom before this JS has executed.
    const initialScale = window.visualViewport.scale;

    // add event listener on viewport resize to disable carousel swipe and
    // increase the resolution of the featured image
    window.visualViewport.addEventListener("resize", () => toggleCarousel(carouselControllers, initialScale));
  }
}
